export const DEFAULT_SERVER_ERROR_MESSAGE = 'Something went wrong'

export const INCORRECT_SERVER_ERROR_MESSAGE_PATTERN = 'No query results'
